export default __webpack_public_path__ + "static/media/chevronRight.ef62bb1b.svg";